import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Collapse } from 'antd'

import { GhostCollapse } from './styled'

// Serves both question lists: by the time the reader reaches the rules they have already learnt
// the gesture. Deliberately not `accordion`: comparing two causes means keeping both open.
const HelpAccordion = props => {
  const { prefix, items, titleKey } = props

  return (
    <GhostCollapse ghost expandIconPosition={'right'}>
      {items.map(item => (
        <Collapse.Panel
          key={item.key}
          header={<FormattedMessage id={`${prefix}.${item.key}.${titleKey}`} />}>
          {item.paragraphs.map(paragraph => (
            <p key={paragraph}>
              <FormattedMessage id={`${prefix}.${item.key}.${paragraph}`} />
            </p>
          ))}
        </Collapse.Panel>
      ))}
    </GhostCollapse>
  )
}
HelpAccordion.propTypes = {
  prefix: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  titleKey: PropTypes.string.isRequired
}
export default HelpAccordion
